"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonMessages_de_de = void 0;
function commonMessages_de_de() {
    return {
        "messages.errors.notinsamecompany": "Sie können nur Nachrichten an jemanden in Ihrer Firma senden!",
        "messages.errors.messagenotfound": "Nachricht konnte nicht gefunden werden.",
        "messages.errors.recipienttypenotfound": "Der folgende Empfängertype konnte nicht gefunden werden: ",
        "messages.errors.recipientnotfound": "Empfänger der Nachricht wurde nicht gefunden.",
        "messages.errors.wrongreseller": "Falscher reseller für diesen Tenant.",
        "messages.errors.isdifferentproject": "Nachricht kann nicht an andere Projekte versendet werden.",
        "messages.errors.isnotprojectmember": "Nachrichtenempfänger ist kein Projektmitglied.",
        "messages.errors.sendingnotallowed": "Nur Projekte und Benutzer dürfen Nachrichten versenden.",
        "messages.system.exportdone": "Ihr Datenexport ist abgeschlossen!",
        "messages.system.downloadexport": "Exportierte Daten herunterladen",
        "messages.system.acceptedinvitation": "hat Ihre Einladung akzeptiert."
    };
}
exports.commonMessages_de_de = commonMessages_de_de;
